export const LOGOS_PATH = '/static-appopensalud/img/logos/'

export const OPENSALUD_LOGO = 'opensalud_healthierlives_color.svg'
export const OPENSALUD_WHITE_LOGO = 'opensalud_healthierlives_white.svg'
export const OPENSALUD_MX_LOGO = 'opensaludhealthier_lives_color_MEX.svg'
export const OPENSALUD_MX_WHITE_LOGO = 'opensaludhealthier_lives_white_MEX.svg'
export const OPENSALUD360_LOGO = 'openhealth_360_healthier_lives_color.svg'
export const OPENSALUD360_WHITE_LOGO = 'openhealth_360_healthier_lives_white.svg'
export const OPENSALUD360_MX_LOGO = 'openhealth_360_healthier_lives_color_MEX.svg'
export const OPENSALUD360_WHITE_MX_LOGO = 'openhealth_360_healthier_lives_white_MEX.svg'
export const OPENLEGAL_LOGO = 'openlegal_blue.svg'
export const ABOGALITYPRO_LOGO = 'openlegalpro_orange.svg'
export const OPENLEGAL360_LOGO = 'openlegal360_orange.svg'
export const UNIPROMEL_LOGO = 'unihealth_blue_unipromel.svg'
export const NEOM_LOGO = 'RGB_Neom_positivo.svg'
export const PRIME_BY_OPENSALUD_LOGO = 'primebyopensalud-healthierlives-color.svg'
export const PRIME_BY_OPENSALUD_LOGO_WHITE = 'primebyopensalud-healthierlives-white.svg'
export const INHEALTH_LOGO = 'inhealth-color.png'

export function getLogoFullPath(logoFileName) {
	return `${LOGOS_PATH}${logoFileName}`
}


// WEBPACK FOOTER //
// ./src/constants/logosFileNames.js